<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Listagem de Regras</p>
    </div>
    {{}}
    <div class="row">
      <lista-unidades-select
        class="col-2"
        v-model="unidade"
      ></lista-unidades-select>

      <q-btn
        class="q-ml-sm col-2"
        label="Exportar"
        color="secondary"
        icon="file_upload"
        dense
        no-caps
        @click="exportar"
      />

      <q-btn
        label="Sincronizar todas regras desta unidade"
        icon="sync"
        dense
        no-caps
        @click="sincronizarFuncao"
        color="primary q-ml-sm"
        :disable="
          $store.state.org.unidadeData.id == undefined ||
          $store.state.org.unidadeData.id == null ||
          $store.state.org.unidadeData.id == ''
        "
        class="col-3"
      />
    </div>

    <div class="col-3 row justify-end q-mt-md">
      <q-input
        outlined
        rounded
        dense
        debounce="300"
        v-model="filter"
        placeholder="Buscar"
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>
    </div>

    <div>
      <section class="q-mt-md" v-for="(regras, index) in data" :key="index">
        <span v-show="false">{{ (regras.tab = "regras") }}</span>
        <q-expansion-item
          class="bg-accent rounded-borders"
          :label="regras.product_group_name"
        >
          <q-separator />
          <q-card class="bg-brand-7">
            <q-card-section>
              <q-btn
                label="Ver Produtos"
                color="primary"
                class="q-ml-sm full-width"
                @click="
                  routeProdutos(
                    regras.product_group_id,
                    regras.product_group_name,
                    'grupo-produtos-adicionar'
                  )
                "
              />
            </q-card-section>
            <q-separator class="q-mb-sm" />
            <q-tabs v-model="regras.tab" class="bg-grey-2 text-secondary" dense>
              <q-tab
                name="regras"
                icon="gavel"
                label="Regras de Unidade (TODOS)"
                :class="{ 'text-grey': regras.tab != 'regras' }"
              />
              <q-tab
                name="ghe"
                icon="psychology_alt"
                label="Regras de Funcao (GHE)"
                :class="{ 'text-grey': regras.tab != 'ghe' }"
              />
              <q-tab
                name="centro"
                icon="business_center"
                label="Regras de Centro de Custo"
                :class="{ 'text-grey': regras.tab != 'centro' }"
              />
              <q-tab
                name="individual"
                icon="person"
                label="Regras Individuais"
                :class="{ 'text-grey': regras.tab != 'individual' }"
              />
            </q-tabs>
            <q-tab-panels v-model="regras.tab" animated>
              <q-tab-panel name="regras">
                <q-card-section>
                  <div class="row justify-between">
                    <span class="text-body1 text-weight-bold"
                      >Regras de Unidade (TODOS)</span
                    >
                    <span>
                      <q-btn
                        label="EDITAR REGRAS DE UNIDADE"
                        color="secondary"
                        class="q-ml-sm"
                        @click="
                          routeProdutos(
                            regras.product_group_id,
                            regras.product_group_name,
                            'grupo-produtos-regras'
                          )
                        "
                    /></span>
                  </div>
                  <div class="row justify-around q-mt-md">
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Unidade</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.vendors"
                        :key="index"
                        >{{ regrasUnidade.name }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Minimo</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.vendors"
                        :key="index"
                        >{{ regrasUnidade.minimum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.vendors"
                        :key="index"
                        >{{ regrasUnidade.maximum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Qtdade Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.vendors"
                        :key="index"
                        >{{ regrasUnidade.max_amount }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Crítico</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.vendors"
                        :key="index"
                        >{{ regrasUnidade?.critico == 0 ? "Não" : "Sim" }}</span
                      >
                    </section>
                  </div>
                </q-card-section>
              </q-tab-panel>
              <q-tab-panel name="ghe">
                <q-card-section>
                  <div class="row justify-between">
                    <span class="text-body1 text-weight-bold"
                      >Regras de Funcao (GHE)</span
                    >
                    <span>
                      <q-btn
                        label="EDITAR REGRAS POR FUNÇÃO"
                        color="secondary"
                        class="q-ml-sm"
                        @click="
                          routeProdutos(
                            regras.product_group_id,
                            regras.product_group_name,
                            'grupo-produtos-processo'
                          )
                        "
                    /></span>
                  </div>
                  <div class="row justify-around q-mt-md">
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Descrição</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.functions"
                        :key="index"
                        >{{ regrasUnidade.name }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Minimo</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.functions"
                        :key="index"
                        >{{ regrasUnidade.minimum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.functions"
                        :key="index"
                        >{{ regrasUnidade.maximum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Qtdade Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.functions"
                        :key="index"
                        >{{ regrasUnidade.max_amount }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Crítico</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.functions"
                        :key="index"
                        >{{ regrasUnidade?.critico == 0 ? "Não" : "Sim" }}</span
                      >
                    </section>
                  </div>
                </q-card-section>
              </q-tab-panel>

              <q-tab-panel name="centro">
                <q-card-section>
                  <div class="row justify-between">
                    <span class="text-body1 text-weight-bold"
                      >Regras de Centro de Custo</span
                    >
                    <span>
                      <q-btn
                        label="EDITAR REGRAS POR CENTRO DE CUSTO"
                        color="secondary"
                        class="q-ml-sm"
                        @click="
                          routeProdutos(
                            regras.product_group_id,
                            regras.product_group_name,
                            'grupo-produtos-centro'
                          )
                        "
                    /></span>
                  </div>
                  <div class="row justify-around q-mt-md">
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Descrição</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.cost_centers"
                        :key="index"
                        >{{ regrasUnidade.name }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Minimo</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.cost_centers"
                        :key="index"
                        >{{ regrasUnidade.minimum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.cost_centers"
                        :key="index"
                        >{{ regrasUnidade.maximum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Qtdade Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.cost_centers"
                        :key="index"
                        >{{ regrasUnidade.max_amount }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Crítico</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.cost_centers"
                        :key="index"
                        >{{ regrasUnidade.critico == 0 ? "Não" : "Sim" }}</span
                      >
                    </section>
                  </div>
                </q-card-section>
              </q-tab-panel>

              <q-tab-panel name="individual">
                <q-card-section>
                  <div class="row justify-between">
                    <span class="text-body1 text-weight-bold"
                      >Regras Individuais</span
                    >
                  </div>
                  <div class="row justify-around q-mt-md">
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Descrição</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.users"
                        :key="index"
                        >{{ regrasUnidade.name }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Minimo</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.users"
                        :key="index"
                        >{{ regrasUnidade.minimum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder">
                        Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.users"
                        :key="index"
                        >{{ regrasUnidade.maximum_days }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Qtdade Max</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.users"
                        :key="index"
                        >{{ regrasUnidade.max_amount }}</span
                      >
                    </section>
                    <section class="column">
                      <span class="text-subtitle2 text-weight-bolder"
                        >Crítico</span
                      >
                      <q-separator class="q-mt-sm" />
                      <span
                        v-for="(regrasUnidade, index) in regras.users"
                        :key="index"
                        >{{ regrasUnidade.critico == 0 ? "Não" : "Sim" }}</span
                      >
                    </section>
                  </div>
                </q-card-section>
              </q-tab-panel>
            </q-tab-panels>
          </q-card>
        </q-expansion-item>
      </section>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const router = useRouter();
    const filter = ref("");
    const data = ref([]);
    const $q = useQuasar();
    const unidade = ref();

    const getRegras = async () => {
      let response = await store.dispatch("grupoProdutos/pessoaRegras", {
        search: filter.value,
        unidade: store.state.org.unidadeData.id,
      });

      data.value = response.data.data;
    };

    const exportar = async () => {
      try {
        await store.dispatch("grupoProdutos/exportarListarRegras", {
          unidade: store.state.org.unidadeData.id,
          download: "xlsx",
        });
        $q.notify({
          message: "Dados exportados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao exportar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const sincronizarFuncao = async () => {
      try {
        await store.dispatch("grupoProdutos/sincronizarFuncao", {
          unidade: unidade.value.id,
        });
        $q.notify({
          message: "Sincronizado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Selecione uma unidade para realizar a indexação",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const routeProdutos = async (id, name, rota) => {
      let dados = { id: id, nome: name };

      router.push({
        name: `${rota}`,
        params: { id: JSON.stringify(dados) },
      });
    };

    onMounted(getRegras);

    watch(
      () => store.state.org.unidadeData,
      () => {
        getRegras();
      }
    );

    watch(
      () => filter.value,
      () => {
        getRegras();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      getRegras,
      data,
      filter,
      exportar,
      sincronizarFuncao,
      routeProdutos,
      unidade,
      tab: ref("regras"),
    };
  },
};
</script>

<style scoped>
.teste {
  color: red;
}
</style>
